module.exports = "/assets/data/dadec63c080751686f960a502c3f9764-SA73.data.json";